import cookies from 'js-cookie';

export const getPlatformID = (): string | undefined => cookies.get('platformId');
